// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"72884b85","89":"7af51a7c","283":"8fc12015","384":"13f4192b","413":"8639743c","534":"61ddb0ed","787":"f2e592f8","830":"05c78093","995":"1741649b"}[chunkId] + ".chunk.js";
};